import {
  FETCH_API_KEYS_REQUEST,
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_FAILURE,
  CREATE_API_KEY_REQUEST,
  CREATE_API_KEY_SUCCESS,
  CREATE_API_KEY_FAILURE,
  DELETE_API_KEY_REQUEST,
  DELETE_API_KEY_SUCCESS,
  DELETE_API_KEY_FAILURE,
  RESET_API_KEY_STATE
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

export const getUserApiKeys = () => async dispatch => {
  dispatch({ type: FETCH_API_KEYS_REQUEST });

  try {
    const response = await fetch(webPortalApi.buildApiUrl('user/apikey'), {
      ...getRequestOptions()
    });

    if (!response.ok) {
      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.includes('application/json')) {
        const errorData = await response.json();

        throw new Error(errorData.errorMessage || 'Failed to create API key');
      }

      throw new Error('Failed to create API key');
    }

    const data = await response.json();

    dispatch({
      type: FETCH_API_KEYS_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: FETCH_API_KEYS_FAILURE,
      payload: error
    });
  }
};

export const createApiKey = keyData => async (dispatch, getState) => {
  dispatch({ type: CREATE_API_KEY_REQUEST });

  try {
    const response = await fetch(webPortalApi.buildApiUrl('user/apikey'), {
      ...getRequestOptions(),
      method: 'POST',
      body: JSON.stringify(keyData)
    });

    if (!response.ok) {
      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.includes('application/json')) {
        const errorData = await response.json();

        throw new Error(errorData.errorMessage || 'Failed to create API key');
      }

      throw new Error('Failed to create API key');
    }

    const data = await response.json();

    dispatch({
      type: CREATE_API_KEY_SUCCESS,
      payload: data
    });

    // Refresh the API keys list
    const state = getState();
    const userId = state.user?.id;
    if (userId) {
      dispatch(getUserApiKeys(userId));
    }

    return data;
  } catch (error) {
    dispatch({
      type: CREATE_API_KEY_FAILURE,
      payload: error
    });

    throw error;
  }
};

export const deleteApiKey = keyId => async (dispatch, getState) => {
  dispatch({ type: DELETE_API_KEY_REQUEST });

  try {
    const response = await fetch(webPortalApi.buildApiUrl(`user/apikey/${keyId}`), {
      ...getRequestOptions(),
      method: 'DELETE'
    });

    if (!response.ok) {
      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.includes('application/json')) {
        const errorData = await response.json();

        throw new Error(errorData.errorMessage || 'Failed to create API key');
      }

      throw new Error('Failed to create API key');
    }

    dispatch({
      type: DELETE_API_KEY_SUCCESS,
      payload: keyId
    });

    // Refresh the API keys list
    const state = getState();
    const userId = state.user?.id;
    if (userId) {
      dispatch(getUserApiKeys(userId));
    }
  } catch (error) {
    dispatch({
      type: DELETE_API_KEY_FAILURE,
      payload: error
    });

    throw error;
  }
};

export const deleteApiKeysOnSignOut = () => async () => {
  try {
    const response = await fetch(webPortalApi.buildApiUrl('user/apikey/sign-out'), {
      ...getRequestOptions(),
      method: 'DELETE'
    });

    if (!response.ok) {
      throw new Error('Failed to delete API keys on sign-out');
    }
  } catch (error) {
    console.error('API key cleanup on sign-out failed', error);
  }
};

export const resetApiKeyState = () => dispatch => {
  dispatch({ type: RESET_API_KEY_STATE });
};
